<script>
    import R, {LOADER} from "../lib/requests";
    import {CHECKIN_STATUS} from "../lib/constants.js";
    import members from "../stores/members";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate} from "../lib/lib";
    import A from "../lib/Router/A.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import HotelControl from "../components/controls/HotelControl.svelte";


    const tableColumns = [
        {key: 'hotel_id', title: 'HOTEL', sortable: true},
        {key: 'name', title: 'NAME', sortable: true},
        {key: 'email', title: 'EMAIL', sortable: true},
        {key: 'date_in', title: 'DATES', sortable: true},
        {key: 'total_persons', title: 'PERSONS'},
        {key: 'created_at', title: 'CREATED', sortable: true, sort_way: 'DESC'},
        {key: 'user', title: 'USER'},
        {key: '', title: '', hidden: !user.isAdmin()},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];


    let list = null;
    let total = null;
    let page = 1;
    let selectedId = null;
    let search = {
        date_from: null,
        date_to: null,
        hotel_id: null,
        member_id: null,
        term: null,
        status_id: '',
        limit: 50,
        offset: 0,
        sort_field: null,
        sort_way: null,
    }

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            total = result.total;
        }

        const onFailure = err => {
        };

        search.offset = ($members.page - 1) * $members.search.limit;

        R.handle(R.checkin.index, search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = null;
        search.date_to = null;
        search.hotel_id = null;
        search.member_id = null;
        search.term = null;
        search.status_id = '';
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onDelete = (item) => {
        let prompt = '';
        if (item.points && item.status_id == CHECKIN_STATUS.CONFIRMED) {
            prompt = `<b>This will remove ${item.points} points from member!</b>\n`;
        }
        Alert.delete("Delete check in", `You are about to delete ${item.member_id > 0 ? "member's" : ""} check in from "${item.hotel.name}".\n${prompt}Are you sure?`, () => deleteCheckin(item.id));
    }

    const deleteCheckin = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            Notifier.showMessage("Member check is deleted");
        }

        const onFailure = err => {

        };

        R.handle(R.checkin.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Check ins" controls={ pageHeaderControls } on:reload={ load }/>

<div class="panel panel-simple pb-2 mb-5">
    <div class="row row-condensed">
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">from</div>
                <input type="date" class="form-control" bind:value={ search.date_from } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">to</div>
                <input type="date" class="form-control" bind:value={ search.date_to } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <select class="form-select" bind:value="{ search.status_id }" on:change={ onSearch }>
                <option value="">status</option>
                <option value="{ CHECKIN_STATUS.NEW }">New</option>
                <option value="{ CHECKIN_STATUS.CONFIRMED }">Confirmed</option>
                <option value="{ CHECKIN_STATUS.REFUSED }">Rejected</option>
            </select>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <HotelControl bind:hotelId="{ search.hotel_id }" on:change={ onSearch } placeholder="hotel"/>
        </div>
        <div class="column-condensed col-xl-4 col-lg-4 col-md-5 pt-2">
            <input type="text" class="form-control" bind:value="{ search.term }" on:change={ onSearch }
                   placeholder="name or email">
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>CLEAR</button>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>SEARCH</button>
        </div>
    </div>
</div>


<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">view { item } / page</option>
            {/each}
        </select>
    </div>
    {#if list && list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Entries: <strong>{ total }</strong></span>
            <span class="listing-info hidden-xs">Page: <strong>{ page }</strong></span>
        </div>
    {/if}
</div>

{#if list}
    {#if list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td class="first-column">
                        {#if item.member_id > 0}
                            <div class="status status-{ item.status_id}"></div>
                            <A href="/app/member-checkin/{ item.id }" class="is-link">{ item.hotel.name }</A>
                        {:else}
                            <div class="status status-no-member"></div>
                            <A href="/app/user-checkin/{ item.id }" class="is-link">{ item.hotel.name }</A>
                        {/if}
                    </td>
                    <td class="text-gray">
                        <div class="d-flex align-items-center gap-2">
                            <div class:no-member={item.member_id == 0}>
                                <AppIcon icon="member"/>
                            </div>
                            {#if item.member_id > 0}
                                <a href="/app/member/{item.member_id}" class="is-link" target="_blank">{ item.name }</a>
                            {:else}
                                { item.name }
                            {/if}
                        </div>
                    </td>
                    <td class="text-gray">{ item.email }</td>
                    <td class="dates-column text-gray">
                        { formatDate(item.date_in, 'd-m-y') } - { formatDate(item.date_out, 'd-m-y') }
                    </td>
                    <td class="numeric-column text-gray text-end">{ item.total_persons }</td>
                    <td class="datetime-column text-gray">{ formatDate(item.created_at, 'd-m-y H:i') }</td>
                    <td class="text-gray hidden-xs">
                        {#if item.user}
                            { item.user.name }
                        {/if}
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column">
                            <button class="btn btn-action" title="delete check in" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" page="{ page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            No entries found.
        </div>
    {/if}
{/if}

<style>
    .first-column {
        position: relative;
    }

    .dates-column {
        width: 190px;
    }

    .no-member {
        color: #ccc;
    }

    .status {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background-color: #efefef;
    }

    /* new */
    .status-0 {
    }

    /* confirmed */
    .status-1 {
        background-color: #ff9800;
    }

    /* on refused */
    .status-2 {
        background-color: #f44336;
    }

    .status-no-member {
        background-color: #efefef;
    }
</style>